
export const buildQueryString = (params) =>
    Object.entries(params)
        .flatMap(([key, value]) => {
            if (value == null) return [];
            if (Array.isArray(value))
                return value.map((v) => `${key}[]=${encodeURIComponent(v)}`);
            return [`${key}=${encodeURIComponent(value)}`];
        })
        .join('&');
